import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-input-filled" }
const _hoisted_3 = { style: {"margin-bottom":"0.25rem"} }
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "p-ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Badge = _resolveComponent("Badge")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentClassFieldsWithDocumentFields, (fieldView) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: fieldView.documentClassField.id,
        class: _normalizeClass([
					'p-field',
					!fieldView.documentClassField.colSize ? 'p-col-12' : fieldView.documentClassField.colSize,
					{'low-field': _ctx.store.state.userSettings.viewSettings.smallDistanceBetweenFields === true},
				])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", {
              class: "p-mb-3",
              for: fieldView.documentClassField.name
            }, [
              _createTextVNode(_toDisplayString(_ctx.getTranslatedDescription(fieldView.documentClassField)) + " ", 1),
              (fieldView.documentField.alternatives.length > 1)
                ? _withDirectives((_openBlock(), _createBlock(_component_Badge, {
                    key: 0,
                    value: fieldView.documentField.alternatives.length,
                    severity: "warning"
                  }, null, 8, ["value"])), [
                    [_directive_tooltip, _ctx.$t('Squeeze.Validation.General.CountAlternatives', { count: fieldView.documentField.alternatives.length })]
                  ])
                : _createCommentVNode("", true)
            ], 8, _hoisted_4)
          ]),
          ((fieldView.documentClassField.dataType.toLowerCase() === 'text' || fieldView.documentClassField.dataType.toLowerCase() === 'date')
								&& (!fieldView.documentClassField.lookup || fieldView.documentClassField.lookup.active === false)
								&& fieldView.documentField.alternatives.length <= 1
								|| (_ctx.isReadOnlyMode && fieldView.documentField.alternatives.length > 1)
								|| (_ctx.isReadOnlyMode && fieldView.documentClassField.dataType.toLowerCase() === 'text' && fieldView.documentClassField.lookup && fieldView.documentClassField.lookup.active === true)
								|| (fieldView.documentClassField.readonly && fieldView.documentClassField.dataType.toLowerCase() !== 'amount'))
            ? _withDirectives((_openBlock(), _createBlock(_component_InputText, {
                key: 0,
                id: fieldView.documentClassField.name,
                "aria-describedby": fieldView.documentClassField.name + '-help',
                type: "text",
                class: _normalizeClass([
								{'validation-field': _ctx.store.state.userSettings.viewSettings.smallDistanceBetweenFields === false},
								{'p-invalid': fieldView.documentField.value.state === 'ERROR'},
								{'forceapproval': fieldView.documentField.value.state === 'FORCEAPPROVAL'},
								{'valid': fieldView.documentField.value.state === 'OK'},
								{'readonly': fieldView.documentField.readonly || _ctx.isReadOnlyMode},
							]),
                modelValue: _ctx.fields[fieldView.index].value.value,
                "onUpdate:modelValue": ($event: any) => ((_ctx.fields[fieldView.index].value.value) = $event),
                onFocus: ($event: any) => (_ctx.onFocusField($event, fieldView.documentField)),
                onChange: ($event: any) => (_ctx.emitValidationRequest($event, fieldView.documentField)),
                onKeydown: [
                  _withKeys(($event: any) => (_ctx.onEnter($event, fieldView.documentField)), ["enter"]),
                  _withKeys(($event: any) => (_ctx.onEnter($event, fieldView.documentField)), ["tab"])
                ],
                ref_for: true,
                ref: el => { _ctx.setFieldReference(el, fieldView.documentField) },
                readonly: fieldView.documentField.readonly || _ctx.isReadOnlyMode
              }, null, 8, ["id", "aria-describedby", "class", "modelValue", "onUpdate:modelValue", "onFocus", "onChange", "onKeydown", "readonly"])), [
                [
                  _directive_tooltip,
                  (fieldView.documentField.value.state && fieldView.documentField.value.state.toLowerCase() !== 'error') ? '' : fieldView.documentField.value.errorText,
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true),
          ((!_ctx.isReadOnlyMode && fieldView.documentClassField.dataType.toLowerCase() === 'text' && fieldView.documentClassField.lookup && fieldView.documentClassField.lookup.active === true && !fieldView.documentClassField.readonly)
								|| (!_ctx.isReadOnlyMode && fieldView.documentField.alternatives.length > 1 && !fieldView.documentClassField.readonly))
            ? _withDirectives((_openBlock(), _createBlock(_component_AutoComplete, {
                key: 1,
                id: fieldView.documentClassField.name,
                "aria-describedby": fieldView.documentClassField.name + '-help',
                type: "text",
                class: _normalizeClass([
								{'validation-field': _ctx.store.state.userSettings.viewSettings.smallDistanceBetweenFields === false},
								{'p-invalid': fieldView.documentField.value.state === 'ERROR'},
								{'forceapproval': fieldView.documentField.value.state === 'FORCEAPPROVAL'},
								{'valid': fieldView.documentField.value.state === 'OK'},
								{'readonly': fieldView.documentField.readonly || _ctx.isReadOnlyMode},
								{'amount-field': fieldView.documentClassField.dataType.toLowerCase() === 'amount'},
							]),
                inputClass: [
								{'validation-field': _ctx.store.state.userSettings.viewSettings.smallDistanceBetweenFields === false},
								{'p-invalid': fieldView.documentField.value.state === 'ERROR'},
								{'forceapproval': fieldView.documentField.value.state === 'FORCEAPPROVAL'},
								{'valid': fieldView.documentField.value.state === 'OK'},
								{'readonly': fieldView.documentField.readonly || _ctx.isReadOnlyMode},
								{'amount-field': fieldView.documentClassField.dataType.toLowerCase() === 'amount'},
							],
                modelValue: _ctx.fields[fieldView.index].value.value,
                "onUpdate:modelValue": ($event: any) => ((_ctx.fields[fieldView.index].value.value) = $event),
                onFocus: ($event: any) => (_ctx.onFocusField($event, fieldView.documentField)),
                onBlur: ($event: any) => (_ctx.emitValidationRequest($event, fieldView.documentField)),
                onKeydown: [
                  _withKeys(($event: any) => (_ctx.onEnter($event, fieldView.documentField)), ["enter"]),
                  _withKeys(($event: any) => (_ctx.onEnter($event, fieldView.documentField)), ["tab"]),
                  ($event: any) => (_ctx.onKeydown($event, fieldView.documentField))
                ],
                ref_for: true,
                ref: el => { _ctx.setFieldReference(el, fieldView.documentField) },
                readonly: fieldView.documentField.readonly || _ctx.isReadOnlyMode,
                minLength: fieldView.documentClassField.lookup.minInputLength,
                suggestions: _ctx.filteredValues[fieldView.documentClassField.name],
                field: "label",
                onClick: ($event: any) => (_ctx.onClickAutocomplete($event, fieldView.documentField)),
                onComplete: ($event: any) => (_ctx.searchAutocomplete($event, fieldView.documentField)),
                onItemSelect: ($event: any) => (_ctx.onItemSelect($event, fieldView.documentClassField)),
                onItemHover: ($event: any) => (_ctx.onHoverItemAutocomplete($event, fieldView.documentClassField)),
                forceSelection: (fieldView.documentClassField.lookup && fieldView.documentClassField.lookup.active === true) && !fieldView.documentClassField.lookup.allowCustomValues,
                autoHighlight: true,
                dropdownMode: 'current',
                dropdown: !_ctx.isReadOnlyMode && (fieldView.documentField.alternatives.length > 1  || fieldView.documentField.lookup.minInputLength === 0)
              }, {
                item: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(slotProps.item.label), 1)
                ]),
                _: 1
              }, 8, ["id", "aria-describedby", "class", "inputClass", "modelValue", "onUpdate:modelValue", "onFocus", "onBlur", "onKeydown", "readonly", "minLength", "suggestions", "onClick", "onComplete", "onItemSelect", "onItemHover", "forceSelection", "dropdown"])), [
                [
                  _directive_tooltip,
                  (fieldView.documentField.value.state && fieldView.documentField.value.state.toLowerCase() !== 'error') ? '' : fieldView.documentField.value.errorText,
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true),
          (fieldView.documentClassField.dataType.toLowerCase() === 'amount' && fieldView.documentField.alternatives.length <= 1)
            ? _withDirectives((_openBlock(), _createBlock(_component_InputText, {
                key: 2,
                id: fieldView.documentClassField.name,
                modelValue: _ctx.fields[fieldView.index].value.value,
                "onUpdate:modelValue": ($event: any) => ((_ctx.fields[fieldView.index].value.value) = $event),
                class: _normalizeClass([
								{'validation-field': _ctx.store.state.userSettings.viewSettings.smallDistanceBetweenFields === false},
								{'p-invalid': fieldView.documentField.value.state === 'ERROR'},
								{'forceapproval': fieldView.documentField.value.state === 'FORCEAPPROVAL'},
								{'valid': fieldView.documentField.value.state === 'OK'},
								{'readonly': fieldView.documentField.readonly || _ctx.isReadOnlyMode},
								'amount-field',
							]),
                onFocus: ($event: any) => (_ctx.onFocusField($event, fieldView.documentField)),
                onChange: ($event: any) => (_ctx.emitValidationRequest($event, fieldView.documentField)),
                onKeydown: [
                  _withKeys(($event: any) => (_ctx.onEnter($event, fieldView.documentField)), ["enter"]),
                  _withKeys(($event: any) => (_ctx.onEnter($event, fieldView.documentField)), ["tab"])
                ],
                ref_for: true,
                ref: el => { _ctx.setFieldReference(el, fieldView.documentField) },
                readonly: fieldView.documentField.readonly || _ctx.isReadOnlyMode
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "class", "onFocus", "onChange", "onKeydown", "readonly"])), [
                [
                  _directive_tooltip,
                  (fieldView.documentField.value.state && fieldView.documentField.value.state.toLowerCase() !== 'error') ? '' : fieldView.documentField.value.errorText,
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true)
        ])
      ], 2)), [
        [_vShow, !fieldView.documentField.hidden]
      ])
    }), 128))
  ]))
}